import React from 'react';

const Resume = () => {
  return (
    <div className="h-96 w-full overflow-auto rounded-[32px] bg-[#EFF7F7] px-[40px] py-11 scrollbar-hide">
      <img
        src="/images/resume.png"
        className="rounded-lg shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]"
        alt="resume"
      />
    </div>
  );
};

export default Resume;
